export const GET_NOTIFICATIONS_EMAIL = "GET_NOTIFICATIONS_EMAIL"
export const GET_NOTIFICATIONS_EMAIL_SUCCESS = "GET_NOTIFICATIONS_EMAIL_SUCCESS"
export const GET_NOTIFICATIONS_EMAIL_FAIL = "GET_NOTIFICATIONS_EMAIL_FAIL"

export const SAVE_NOTIFICATION_EMAIL = "SAVE_NOTIFICATION_EMAIL"
export const SAVE_NOTIFICATION_EMAIL_SUCCESS = "SAVE_NOTIFICATION_EMAIL_SUCCESS"
export const SAVE_NOTIFICATION_EMAIL_FAIL = "SAVE_NOTIFICATION_EMAIL_FAIL"

export const DELETE_NOTIFICATION_EMAIL = "DELETE_NOTIFICATION_EMAIL"
export const DELETE_NOTIFICATION_EMAIL_SUCCESS = "DELETE_NOTIFICATION_EMAIL_SUCCESS"
export const DELETE_NOTIFICATION_EMAIL_FAIL = "DELETE_NOTIFICATION_EMAIL_FAIL"

export const EDIT_NOTIFICATION_EMAIL = "EDIT_NOTIFICATION_EMAIL"
export const EDIT_NOTIFICATION_EMAIL_SUCCESS = "EDIT_NOTIFICATION_EMAIL_SUCCESS"
export const EDIT_NOTIFICATION_EMAIL_FAIL = "EDIT_NOTIFICATION_EMAIL_FAIL"

export const CLEAN_NOTIFICATIONS_EMAIL = "CLEAN_NOTIFICATIONS_EMAIL"
/*AREA*/
export const GET_AREA = "GET_AREA"
export const GET_AREA_SUCCESS = "GET_AREA_SUCCESS"
export const GET_AREA_FAIL = "GET_AREA_FAIL"
/*SEND EMAIL*/
export const SEND_EMAIL = "SEND_EMAIL"
export const SEND_EMAIL_SUCCESS = "SEND_EMAIL_SUCCESS"
export const SEND_EMAIL_FAIL = "SEND_EMAIL_FAIL"